<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Particuliere verhuizing?</h1>
      <p>
        Of u nu een zakelijke, internationale of particuliere verhuizing op het
        programma heeft staan: via Alleverhuizers.nl kunt u tot honderden euro’s
        besparen als u gaat verhuizen. Op deze website heeft u namelijk de
        mogelijkheid om volledig gratis en vrijblijvend offertes aan te vragen
        van verschillende professionele verhuisbedrijven bij u in de buurt. Zo
        kunt u de tarieven van deze regionale verhuizers met elkaar vergelijken
        om vervolgens een bewuste keuze te maken voor het bedrijf met de
        aantrekkelijkste offerte. Aangezien een particuliere verhuizing al duur
        genoeg is, bieden we u de uitgelezen mogelijkheid om met deze handige
        methode euro’s over te houden.
      </p>

      <h2>Verhuiskosten</h2>
      <p>
        Een particuliere verhuizing brengt vaak meer uitgaven met zich mee dan u
        vooraf had voorzien. U kunt bijvoorbeeld denken aan de kosten van het
        klussen in uw nieuwe woning, of de aansluitkosten voor gas,
        elektriciteit, de telefoon en internet, maar ook aan overnamegeld voor
        bijvoorbeeld de vloer of bepaalde meubels. Het is altijd verstandig om
        professionele verhuizers in te huren. Maar dat betekent dat u wel wilt
        kunnen vergelijken!
      </p>
      <p>
        Alleverhuizers.nl biedt u de mogelijkheid om geheel gratis offertes te
        ontvangen en te vergelijken van bedrijven in uw eigen regio, terwijl u
        daarvoor alleen de belangrijkste persoonlijke informatie en
        verhuisgegevens hoeft achter te laten. Wij doen de rest: we zorgen dat u
        zo snel mogelijk de beschikking heeft over meerdere offertes en laten
        uiteraard aan u over met welke verhuizers u een overeenkomst sluit. Neem
        geen overhaaste beslissingen en bespaar tot honderden euro’s op
        eenvoudige wijze!
      </p>

      <h2>Particuliere verhuizing snel regelen?</h2>
      <p>
        Om allerlei onnodige stress te voorkomen, kunt u niet snel genoeg
        beginnen met uw particuliere verhuizing. Vraag daarom vandaag nog
        verschillende offertes aan via Alleverhuizers.nl en zorg dat u ruim op
        tijd weet door welk verhuisbedrijf u de verhuizing in goede banen laat
        leiden. Vul direct uw gegevens in!
      </p>
      <p>
        Ook voor een
        <nuxt-link to="/informatie-over-verhuizers/zakelijke-verhuizingen">
          zakelijke verhuizing
        </nuxt-link>
        binnen Nederland of
        <nuxt-link to="/informatie-over-verhuizers/internationale-verhuizingen">
          internationale verhuizing
        </nuxt-link>
        zit u uiteraard goed op Alleverhuizers.nl.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Particuliere verhuizing?',
      headDescription:
        'Heb je een particuliere verhuizing op de agenda staan? Vergelijk gratis meerdere offertes via Alleverhuizers.nl en bespaar tot honderden euro’s!',
    }
  },
}
</script>
